import { FC, useCallback } from 'react';
import { useContextSelector } from 'use-context-selector';
import CopyShoppingListSidePanel from './CopyShoppingListSidePanel';
import { ViewShoppingListsContext } from './ViewShoppingListsContext';

const CopyShoppingListSidePanelContainer: FC = () => {
  const copyingShoppingList = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.copyingShoppingList
  );
  const copyFolderIds = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.copyFolderIds
  );
  const isCopyShoppingListPanelOpen = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.isCopyShoppingListPanelOpen
  );
  const closeCopyShoppingListPanel = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.closeCopyShoppingListPanel
  );
  const copyShoppingList = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.copyShoppingList
  );
  const isCopyingShoppingList = useContextSelector(
    ViewShoppingListsContext,
    (context) => context.isCopyingShoppingList
  );

  const handleCopy = useCallback(
    async (payload: { folderIds: number[]; folderAddUsers: number[] }) => {
      await copyShoppingList(payload);
      closeCopyShoppingListPanel();
    },
    [closeCopyShoppingListPanel, copyShoppingList]
  );

  return (
    <CopyShoppingListSidePanel
      isOpen={isCopyShoppingListPanelOpen}
      shoppingList={copyingShoppingList}
      folderIds={copyFolderIds}
      isCopying={isCopyingShoppingList}
      onClose={closeCopyShoppingListPanel}
      onCopy={handleCopy}
    />
  );
};

export default CopyShoppingListSidePanelContainer;
